<template>
	<div class="prize">
		<div class="balance-wrap mb-30">
			<span class="ml-20" style="font-size: 14px; font-weight: bold;">ギフトポイント残高</span>
			<div class="balance">{{ currentPoint.toLocaleString() }}pt</div>
		</div>

		<div class="prize-wrap" v-for="(row, index) in prizes" :key="index" @click="onPrizeClick(row.is_exchange, row.id)">
			<div class="half-top horizontal-center mb-10">
				<div class="preview-area">
					<preview :image="row.image" :maxH="80"></preview>
				</div>

				<div class="detail ml-20">
					<div class="name bold18">{{ row.name }}</div>
					<div class="stock" :style="stockStyle(row.stock)">残り{{ stock(row.stock) }}個</div>
					<div class="point bold18">{{ row.point.toLocaleString() }}pt</div>
				</div>
			</div>

			<hr/>

			<div class="exchange-wrap bold18 text-center mt-10">
				<div v-if="row.is_exchange">交換可能です。</div>
				<div v-else>あと{{ row.remain.toLocaleString() }}ptで交換可能です。</div>
			</div>
		</div>

		<b-modal :active.sync="isModalActive">
			<confirm-modal title="交換確認" body="景品を交換します。よろしいですか？" okButtonTitle="交換" @ok-click="onModalOkClick" @cancel-click="isModalActive = false"></confirm-modal>
		</b-modal>
	</div>
</template>

<script>
import Preview from '@/components/Preview'
import ConfirmModal from '@/components/ConfirmModal'

export default {
	name: 'Prize',
	components: {
		Preview,
		ConfirmModal,
	},
	data () {
		return {
			prizes: [],
			currentPoint: 0,
			isModalActive: false,
			clickId: '',
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods: {
		onPrizeClick: function(isExchange, clickId) {
			if (!isExchange) return;

			this.clickId = clickId;
			this.isModalActive = true;
		},
		onModalOkClick: async function() {
			this.isModalActive = false;
			let loader = this.$buefy.loading.open();
			let ep = 'prizes/exchange';
			this.$utils.log(ep);

			let data = {
				"id": this.clickId,
			};

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
		stockStyle: function(num) {
			return num ? { 'visibility': 'visible' } : { 'visibility': 'hidden' };
		},
		stock: function(num) {
			return num ? num.toLocaleString() : '';
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'prizes';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.prizes = res.data.list;
				this.currentPoint = res.data.current_point;
				this.$store.commit('updatePoint', this.currentPoint);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.prize-wrap {
	padding: 10px;
	background: #fff;
	margin-bottom: 10px;
	cursor: pointer;

	.preview-area {
		min-width: 142px;
		text-align: center;
	}

	.detail {
		width: 100%;

		.stock {
			border: $commonBorder;
			padding: 5px;
			margin: 5px 0 10px;
		}
	}
}

.balance-wrap {
	color: #fff;
	background: $tabPink;
	padding: 20px 10px 34px;
	margin-left: -$basePadding;
	margin-right: -$basePadding;

	.balance {
		text-align: center;
		background: #fff;
		color: $red;
		font-weight: bold;
		font-size: 24px;
		padding: 20px 0;
	}
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 220px;

	.prize {
		margin-left: $sideMargin;
		margin-right: $sideMargin;

		.balance-wrap {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0;
			padding: 30px;

			span {
				font-size: 26px !important;
				margin: 0 !important;
			}

			.balance {
				width: 465px;
			}
		}
	}
}
</style>
